/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */

export const colour_createc_number = (block, generator) => {
  const color = block.getFieldValue('COLOUR');
  const colours = ['#ffffff', '#ff0000', '#ff6600', '#ffff00', '#00ff00', '#00ffff', '#0000ff', '#ff00ff'];
  const code = colours.indexOf(color);
  return [code, generator.ORDER_ATOMIC];
};

// Solo IF0/DO0: el bloque no tiene mutator, así que nunca hay else if / else.
export const controls_if_no_else = (block, generator) => {
  const argument = generator.valueToCode(block, 'IF0', generator.ORDER_NONE) || 'false';
  const branch = generator.statementToCode(block, 'DO0');
  return `if (${argument}) {
${branch}
}
`;
};

export const createc_logic_compare_ldr = (block, generator) => {
  const lum = block.getFieldValue('LUM') || '';
  const order = generator.ORDER_RELATIONAL;
  const argument0 = generator.valueToCode(block, 'A', order) || '';
  return [`${argument0} == ${lum}`, order];
};

// madero no llama a un "Reestablecer..." sino a LuminariaEdificios(HIGH), como
// en el legacy: es a propósito.
export const createc_floralis_restore_electricity = () => 'floralis_ReestablecerServicioElectrico();\n';
export const madero_createc_restore_electricity = () => 'LuminariaEdificios(HIGH);\n';
export const obelisco_createc_restore_electricity = () => 'Obelisco_ReestablecerServicioElectrico();\n';
export const planetario_createc_restore_electricity = () => 'Planetario_ReestablecerServicioElectrico();\n';
export const createc_retiro_restore_electricity = () => 'EstacionDeRetiro_ReestablecerServicioElectrico();\n';

// El de madero (createc_ciudad_ldr) no lleva prefijo, como en el legacy.
export const floralis_createc_ciudad_ldr = (block, generator) => ['floralis_EstadoLuzSol()', generator.ORDER_ATOMIC];
export const createc_ciudad_ldr = (block, generator) => ['EstadoLuzSol()', generator.ORDER_ATOMIC];
export const ovelisco_createc_ciudad_ldr = (block, generator) => ['Obelisco_EstadoLuzSol()', generator.ORDER_ATOMIC];
export const planetario_createc_ciudad_ldr = (block, generator) => ['Planetario_EstadoLuzSol()', generator.ORDER_ATOMIC];
export const train_createc_ciudad_ldr = (block, generator) => ['EstacionDeRetiro_EstadoLuzSol()', generator.ORDER_ATOMIC];

// Las 5 variantes comparten la key 'setupCode' como el legacy; no colisionan
// porque cada perfil genera su propio programa.
const initialBlockCode = (block, generator, include, configFn) => {
  generator.definitions_.setupCode = `\n#include <${include}>\n`;
  generator.setups_.setupCode = `\n  ${configFn}();\n`;
  generator.setups_.setupCode += generator.statementToCode(block, 'Start');
  return generator.statementToCode(block, 'Repeat');
};

export const createc_floralis_initial_block = (block, generator) => (
  initialBlockCode(block, generator, 'FloralisGenerica.h', 'ConfiguracionInicial_FloralisGenerica')
);
export const createc_madero_initial_block = (block, generator) => (
  initialBlockCode(block, generator, 'PuenteDeLaMujer.h', 'ConfiguracionInicial_PuenteMujer')
);
export const createc_obelisco_initial_block = (block, generator) => (
  initialBlockCode(block, generator, 'Obelisco.h', 'ConfiguracionInicial_Obelisco')
);
export const createc_planetario_initial_block = (block, generator) => (
  initialBlockCode(block, generator, 'Planetario.h', 'ConfiguracionInicial_Planetario')
);
export const createc_retiro_initial_block = (block, generator) => (
  initialBlockCode(block, generator, 'EstacionRetiro.h', 'ConfiguracionInicial_Retiro')
);
